import { BaseEntity } from './../../shared';

export class Item implements BaseEntity {
    constructor(
    	public id?: number, // Just to valid interface
        public customerCode?: number,
        public taxCode?: number,
        public customerName?: string,
        public userId?: number,
        public address?: string,
        public mobile?: number,
        public fax?: number,
        public delegate?: string,
        public email?: string,
        public personContact?: string,
        public bankAccount?: string,
        public bankName?: string,
        public accountHolder?: string,
        public description?: string,
        public customerType?: string,
        public productCode?: number,
        public productName?: string,
        public note?: string,
        public isOrg?: boolean,
        public typeSendInvoice?: number,
        public sendInvoiceByMonth?: boolean,
        public dateSendInvoice?: number,
        public taxIncentives?: boolean,
        public useTotalInvoice?: boolean,
        public useRegisterEmail?: boolean,
        public receivedInvoiceEmail?: string,
    ) {
    }
}
